import React from "react";
import { useNavigate } from "react-router-dom";
import "./ExploreOurServicesNew.css";

/* Vector SVG Icons matching Reference */
const CommercialBuyIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="3" width="16" height="18" rx="2" />
    <line x1="8" y1="7" x2="8.01" y2="7" strokeWidth="2.5" />
    <line x1="12" y1="7" x2="12.01" y2="7" strokeWidth="2.5" />
    <line x1="16" y1="7" x2="16.01" y2="7" strokeWidth="2.5" />
    <line x1="8" y1="11" x2="8.01" y2="11" strokeWidth="2.5" />
    <line x1="12" y1="11" x2="12.01" y2="11" strokeWidth="2.5" />
    <line x1="16" y1="11" x2="16.01" y2="11" strokeWidth="2.5" />
    <line x1="8" y1="15" x2="8.01" y2="15" strokeWidth="2.5" />
    <line x1="12" y1="15" x2="12.01" y2="15" strokeWidth="2.5" />
    <line x1="16" y1="15" x2="16.01" y2="15" strokeWidth="2.5" />
    <path d="M10 21v-3h4v3" />
  </svg>
);

const LeaseDocIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <line x1="10" y1="9" x2="8" y2="9" />
  </svg>
);

const PlotMapIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const RentHomeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9.5L12 3l9 6.5V20a1.5 1.5 0 0 1-1.5 1.5H4.5A1.5 1.5 0 0 1 3 20V9.5z" />
    <path d="M9 21V12h6v9" />
  </svg>
);

const PgCommunityIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const ChevronRightSmall = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const ExploreOurServices = () => {
  const navigate = useNavigate();

  const servicesTop = [
    {
      id: "commercial-buy",
      title: "Buying a commercial property",
      desc: "Shops, offices, land, factories, warehouses and more.",
      route: "/property-search/Commercial/Buy/All/Hyderabad",
      image: "/assets/images/services/commercial_buy.jpg",
      icon: <CommercialBuyIcon />,
      themeClass: "mgh-service-rose",
    },
    {
      id: "commercial-lease",
      title: "Leasing a commercial property",
      desc: "Shops, offices, land, factories, warehouses and more.",
      route: "/property-search/Commercial/Lease/All/Hyderabad",
      image: "/assets/images/services/commercial_lease.jpg",
      icon: <LeaseDocIcon />,
      themeClass: "mgh-service-blue",
    },
    {
      id: "plots-land",
      title: "Buy Plots/Land",
      desc: "Residential Plots, Agricultural Farm lands and more.",
      route: "/property-search/Residential/Buy/Land/Hyderabad",
      image: "/assets/images/services/plots_land.jpg",
      icon: <PlotMapIcon />,
      themeClass: "mgh-service-green",
    },
  ];

  const servicesBottom = [
    {
      id: "rent-home",
      title: "Renting a home",
      desc: "Apartments, builder floors, villas and more.",
      route: "/property-search/Residential/Rent/All/Hyderabad",
      image: "/assets/images/services/rent_home.jpg",
      icon: <RentHomeIcon />,
      themeClass: "mgh-service-amber",
    },
    {
      id: "pg-coliving",
      title: "PG and co-living",
      desc: "Organised, owner and broker listed PGs.",
      route: "/property-search/Residential/Pg/All/Hyderabad",
      image: "/assets/images/services/pg_coliving.jpg",
      icon: <PgCommunityIcon />,
      themeClass: "mgh-service-purple",
    },
  ];

  const handleServiceClick = (route) => {
    navigate(route);
  };

  const renderServiceCard = (service) => (
    <div
      key={service.id}
      className={`mgh-services-card ${service.themeClass}`}
      onClick={() => handleServiceClick(service.route)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleServiceClick(service.route);
        }
      }}
    >
      {/* Left Info Area */}
      <div className="mgh-services-card-left">
        <div className="mgh-services-icon-box" aria-hidden="true">
          {service.icon}
        </div>

        <div className="mgh-services-card-info">
          <h3 className="mgh-services-card-title">{service.title}</h3>
          <p className="mgh-services-card-desc">{service.desc}</p>
        </div>

        <div className="mgh-services-btn" aria-label={`Learn more about ${service.title}`}>
          <span className="mgh-services-btn-text">Learn More</span>
          <span className="mgh-services-btn-arrow">
            <ChevronRightSmall />
          </span>
        </div>
      </div>

      {/* Right Image with Smooth Curved Arch */}
      <div className="mgh-services-card-right">
        <img
          src={service.image}
          alt={service.title}
          className="mgh-services-card-img"
          loading="lazy"
          onError={(e) => {
            e.target.src = "/assets/images/sliderImg/E11.jpg";
          }}
        />
      </div>
    </div>
  );

  return (
    <section className="mgh-services-section" aria-label="Explore Our Services">
      {/* Header Area */}
      <div className="mgh-services-header">
        <div className="mgh-services-header-left">
         
          <h2 className="mgh-services-title">
            Explore Our <span className="mgh-services-highlight">Services</span>
          </h2>
          <p className="mgh-services-subtitle">
            Comprehensive real estate solutions to help you buy, sell, rent or invest with confidence.
          </p>
        </div>

        {/* Decorative Grid Dots */}
        <div className="mgh-services-header-right" aria-hidden="true">
          <div className="mgh-services-decor-dots"></div>
        </div>
      </div>

      {/* 5 Cards Layout (3 Top Row, 2 Bottom Row) */}
      <div className="mgh-services-grid">
        <div className="mgh-services-row-top">
          {servicesTop.map(renderServiceCard)}
        </div>
        <div className="mgh-services-row-bottom">
          {servicesBottom.map(renderServiceCard)}
        </div>
      </div>
    </section>
  );
};

export default ExploreOurServices;